// Opens the common chat queue through the existing newChat store actions.
// Session-bound chat data is dropped; browser-level settings (FCM permission, sound) stay.

export function resetChatContext(store) {
    store.dispatch('newChat/setActiveChat', null)
    store.dispatch('newChat/setList', [])
    store.dispatch('newChat/setMessages', [])
    store.dispatch('newChat/setReference', null)
    store.dispatch('newChat/setLoading', false)
    store.dispatch('newChat/setDetailLoading', false)
    store.dispatch('newChat/setMessagesLoading', false)
    store.dispatch('newChat/setQuickRepliesOpen', false)
    store.dispatch('newChat/clearQuickReply')
    store.dispatch('newChat/setHistorySearchPrefill', '')
    store.dispatch('newChat/setTotalUnread', 0)
    store.dispatch('newChat/setUnreadMyChats', 0)
    store.dispatch('newChat/setTab', 'common')
    store.dispatch('newChat/setSource', 'regular')
}

function isChatBarOpen(store) {
    const bar = store.getters.barNewChat
    return Boolean(bar && bar.value)
}

// The chat list loads only on mount and does not watch tab/source,
// so an already open panel is closed first to make it load the common queue again.
export function openCommonQueue(vm) {
    const store = vm.$store
    const wasOpen = isChatBarOpen(store)
    if (wasOpen) store.dispatch('CHANGE_ACTIVE_BAR', { name: 'newChat', value: false })
    resetChatContext(store)
    return vm.$nextTick().then(() => {
        store.dispatch('CHANGE_ACTIVE_BAR', { name: 'newChat', value: true })
    })
}

export function closeChatBar(store) {
    if (isChatBarOpen(store)) store.dispatch('CHANGE_ACTIVE_BAR', { name: 'newChat', value: false })
}
